export default __webpack_public_path__ + "static/media/AO-4.8e8a8471.jpg";